var TEMPLATE_URL = require('./report.page.html');
angular.module('ikeweb.spike.report').directive('reportPage', [

    function() {
        return {
            replace: true,
            restrict: 'E',
            scope: {
                heading: '=',
                measurements: '=',
                units: '=',
                note: '='
            },
            templateUrl: TEMPLATE_URL,
            transclude: true
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/report/report.page.directive.js
// module id = 580
// module chunks = 0